import React, { useEffect, useState } from "react";
import { Collapse, Descriptions, message } from "antd";
import utils from "utils";
import api from "utils/api";
import Loader from "Components/Loader";
import { Divider } from "@mui/material";
import icons from "Common/Icons";
const { Panel } = Collapse;
import VitalHistoryEdit from "./VitalHistoryEdit";
export const VitalFormData = ({ data, showDate }) => {
  const renderNestedItems = (items) => {
    return items?.map((item, index) => (
      <>
        {item.value && (
          <Descriptions.Item
            label={
              <span style={{ alignSelf: "center", fontWeight: "normal" }}>
                {item.label}
              </span>
            }
            key={index}
          >
            <span style={{ alignSelf: "center", fontWeight: "lighter" }}>
              {item.value} {item.unit}
            </span>
          </Descriptions.Item>
        )}
      </>
    ));
  };

  const renderPanels = () => {
    return data?.map((entry, index) => (
      <Panel
        key={index}
        header={
          showDate && (
            <div style={{ height: "100%", fontWeight: "bold" }}>
              {utils.FormatDate(entry.updated_on, "DATE_14")},
              {utils.FormatDate(entry.updated_on, "TIME_1")}
            </div>
          )
        }
        extra={
          <div
            style={{
              height: "100%",
              // display: "flex",
              // justifyContent: "space-between",
              // gap: "10px",
              color: "#98A2B3",
            }}
          >
            <div>
              <span>Updated By</span>: <span>{entry.updated_by}</span>
            </div>
            <div>
              <span>Created By</span>: <span>{entry.created_by}</span>
            </div>
          </div>
        }
        // collapsible="disabled"
        showArrow={false}
      >
        {entry.required_vitals.filter((vital) => vital.value !== "").length >
          0 && (
          <Descriptions
            size="small"
            // title="Required"
            column={{
              xxl: 5,
              xl: 4,
              lg: 3,
              md: 3,
              sm: 2,
              xs: 1,
            }}
          >
            {renderNestedItems(entry.required_vitals)}
          </Descriptions>
        )}
        {/* <Divider textAlign="left">others</Divider> */}
        {entry.others.length > 0 && (
          <Descriptions
            size="small"
            // title="Others"
            // labelStyle={{ width: "100px"}}
          >
            {renderNestedItems(entry.others)}
          </Descriptions>
        )}
        {entry.comment?.length > 0 && (
          <Descriptions size="small">
            <Descriptions.Item label="Comment">
              <span style={{ alignSelf: "center" }}> {entry.comment}</span>
            </Descriptions.Item>
          </Descriptions>
        )}
      </Panel>
    ));
  };
  return (
    <>
      {data.length > 0 ? (
        <Collapse
          // style={{ backgroundColor: "inherit" }}
          bordered={false}
          // expandIconPosition="start"
          // className="vitalListContainer"
          ghost={true}
          showArrow={false}
          collapsible="icon"
          defaultActiveKey={utils.generateNumbersArray(data)}
        >
          {renderPanels()}
        </Collapse>
      ) : (
        <div className="emptyHistoryDiv">
          <div className="emptyHistoryTitle">
            <img
              src={icons.empty_folder_icon}
              style={{ width: "24px", height: "24px" }}
              alt=" "
            />
            No data to show
          </div>
          <div className="emptyHistorySubTitle">
            Submit Vital Form to show History
          </div>
        </div>
      )}
    </>
  );
};

const YourComponent = (props) => {
  const [load, setLoader] = useState(true);
  const [responseData, setResponseData] = useState([]);
  const patient_id = props?.patientDetails?.patient_id
    ? props?.patientDetails?.patient_id
    : "";
  useEffect(() => {
    api
      .fetch_vitals_history(patient_id)
      .then((response) => {
        if (response.data?.status == 200) {
          setResponseData(response.data.data.results);
          setLoader(false);
        } else {
          setLoader(false);
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        message.error("something went wrong");
      });
  }, []);

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div>
          {responseData &&
            (props?.patientDetails?.patient_id ? (
              <VitalHistoryEdit data={responseData} />
            ) : (
              <VitalFormData data={responseData} showDate={true} />
            ))}
        </div>
      )}
    </>
  );
};
export default YourComponent;
